<template>
  <div v-loading.fullscreen.lock="loading">
    <!-- 移库 -->
    <el-dialog :title="$t('message.moveTheLibrary')" :close-on-click-modal="false"
      :visible.sync="$parent.moveTheLibraryDialogVisible" width="1710px" center>
      <div class="content">
        <div class="table">
          <ol>
            <li class="flex05">NO</li>
            <!--  库位-->
            <li class="flex15">
              {{ $t("message.location") }}
            </li>
            <!--  装箱信息 -->
            <li class="flex18">
              {{ $t("message.packingInformation") }}
            </li>
            <!-- 授权属性 -->
            <li>
              {{ $t("message.attributeOfAuthorization") }}
            </li>
            <!--  订单号 -->
            <li class="flex15">
              {{ $t("message.orderNumber") }}
            </li>
            <!-- 番号 -->
            <li class="flex05">
              {{ $t("message.mash") }}
            </li>
            <!--照片-->
            <li>
              {{ $t("message.pic") }}
            </li>
            <!-- 类型 -->
            <li>{{ $t("message.type") }}</li>
            <!-- 商品属性 -->
            <li class="flex15">{{ $t("message.commodityAttribute") }}</li>
            <!--交易号  -->
            <li class="flex15">{{ $t("message.transactionNumber") }}</li>
            <!--库位数量  -->
            <li>{{ $t("message.numberOfStorageLocations") }}</li>
            <!-- 移库数量 -->
            <li>{{ $t("message.quantityOfWarehouseTransfer") }}</li>
          </ol>
          <ul v-for="(item, index) in list" :key="index">
            <li class="flex05">{{ item.rowNumber }}</li>
            <!--  库位-->
            <li class="flex15">
              <div class="template">
                <p>{{ item.grid_number.split("】-")[0] }}】-</p>
                <p style="color: #fa5058">
                  {{ item.grid_number.split("】-")[1] }}
                </p>
              </div>
            </li>
            <!--  装箱信息 -->
            <li class="flex18">
              <div class="template">
                <p v-for="(items, indexs) in item.order_box" :key="indexs">
                  {{ items.order_sn }}-
                  <span style="color: #fa5058">{{ items.box_no }}</span>
                </p>
              </div>
            </li>
            <!-- 授权属性 -->
            <li>
              {{
                item.order_purchase.order.user.authorized ? "授权" : "未授权"
              }}
            </li>
            <!--  订单号 -->
            <li class="flex15">
              <div class="template">
                <p>
                  <router-link :to="
                    '/orderPaymentDetail?order_sn=' +
                    item.order_purchase.order_sn
                  " target="_blank" style="color: #fa5058">{{ item.order_purchase.order_sn }}</router-link>
                </p>
                <p>{{ item.order_purchase.order.user.realname }}</p>
              </div>
            </li>
            <!-- 番号 -->
            <li class="flex05">
              {{ item.order_purchase.order_detail.sorting }}
            </li>
            <!--照片-->
            <li>
              <el-popover placement="right" width="300" trigger="hover">
                <img :src="item.order_purchase.order_detail.pic" alt="" style="width: 300px; height: 300px" />
                <a :href="`https://detail.1688.com/offer/${item.order_purchase.order_detail.goods_id}.html`"
                  target="_blank" slot="reference">
                  <img :src="item.order_purchase.order_detail.pic" alt="" style="width: 60px; height: 60px" />
                </a>
              </el-popover>
            </li>
            <!-- 类型 -->
            <li>
              <div class="template">
                <p>{{ item.order_purchase.order_detail.from_platform }}</p>
                <!-- 商品id -->
                <p>
                  {{ $t("message.goodsID") }}:{{
                    item.order_purchase.order_detail.goods_id
                  }}
                </p>
              </div>
            </li>
            <!-- 商品属性 -->
            <li class="flex15">
              <div class="template">
                <el-tooltip placement="bottom">
                  <div slot="content">
                    <div class="row" v-for="(itemDetail, itemIndex) in item.order_purchase
                      .order_detail.detail_y" :key="itemIndex" style="margin-bottom: 5px">
                      {{ itemDetail.key }}：{{ itemDetail.value }}
                    </div>
                  </div>
                  <div>
                    <div class="row" v-for="(itemDetail, itemIndex) in item.order_purchase
                      .order_detail.detail_y" :key="itemIndex">
                      {{ itemDetail.key }}：{{ itemDetail.value }}
                    </div>
                  </div>
                </el-tooltip>
              </div>
            </li>
            <!--交易号  -->
            <li class="flex15">{{ item.order_purchase.purchase_no }}</li>
            <!--库位数量  -->
            <li>{{ item.num }}</li>
            <!-- 移库数量 -->
            <li>
              <el-input v-model="item.yiku_num" onkeyup.native="value=value.replace(/^(0+)|[^\d]+/g,'')" type="number"
                onfocus="this.select()" @input="maxNum(item, index)"></el-input>
            </li>
          </ul>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--重置-->
        <el-button @click="$parent.moveTheLibraryDialogVisible = false">{{
          $t("message.cancel")
        }}</el-button>
        <!--保存-->
        <el-button type="primary" @click="save">{{
          $t("message.ok")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    list: { type: Array },
  },
  data() {
    return {
      loading: false,
    };
  },
  created() {
    console.log(this.list);
  },
  methods: {
    // 最大废弃值
    maxNum(item, i) {
      if (item.yiku_num > item.num) {
        this.list[i].yiku_num = item.num;
        this.$message.error("移库数量不能大于库位数量");
      }
    },
    save() {
      let arr = [];
      for (let i = 0; i < this.list.length; i++) {
        if (this.list[i].yiku_num == 0 || this.list[i].yiku_num == "") {
          this.$alert("移库数量不能为0或者为空", "提示", {
            confirmButtonText: "确定",
            center: true,
          });
          return;
        }
        arr.push({
          wms_stock_id: this.list[i].id,
          num: this.list[i].yiku_num,
        });
      }
      this.$parent.getmoveTheLibraryList(arr);
    },
  },
};
</script>
<style lang='scss' scoped>
.content {
  margin: 0 15px;
  background: #f8f8f8;
  border-radius: 0px 8px 8px 8px;
  padding: 24px;

  .table {
    .flex05 {
      flex: 0.5;
    }

    .flex15 {
      flex: 1.5;
    }

    .flex18 {
      flex: 1.8;
    }

    ul {
      padding: 20px 0;

      /deep/.el-input {
        width: 80%;
      }

      .template {
        width: 100%;
        text-align: center;
      }
    }

    .imgList {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      padding-left: 5px;

      .imgs {
        margin: 0 10px 10px 0px;
        width: 60px;
        height: 60px;
        line-height: 60px;
        text-align: center;
        border: 1px dashed #ccc;
        border-radius: 3px;

        /deep/.el-upload {
          width: 60px;
          height: 60px;
        }

        img {
          width: 100%;
          height: 100%;
        }

        &:nth-child(even) {
          margin-right: 0;
        }

        &:nth-child(n + 2) {
          margin-bottom: 0;
        }
      }
    }
  }
}
</style>